export enum TitleColor {
  BLACK = 'black',
  WHITE = 'white',
}
